import React from "react";
import { TargetIcon, EyeIcon } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import { images } from "../../i18n/translations";
import { Reveal } from "../ui/Reveal";
export function About() {
  const {
    t
  } = useLanguage();
  return <section id="nosotros" className="w-full bg-white py-20 sm:py-28" data-id="element-112" data-mp="ypbornyqi00e">
      <div className="max-w-content mx-auto px-4 sm:px-6" data-id="element-113" data-mp="yq37vzb5a59s">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-114" data-mp="ayxsfl949f00">
          <Reveal className="relative" data-id="element-115" data-mp="60we1dmmy3uv">
            <div className="relative" data-id="element-116" data-mp="61xs7qyy76gt">
              <img src={images.about} alt="Cargador frontal operando en la cantera" loading="lazy" className="w-full h-[420px] lg:h-[500px] object-cover rounded-sm shadow-xl" data-id="element-117" data-mp="5ytfu6bbx4f2" />
              <div className="absolute -bottom-6 -right-4 hidden sm:block bg-orange text-white px-8 py-6 rounded-sm shadow-lg max-w-[220px]" data-id="element-118" data-mp="3nftcuu8b7qpd">
                <p className="font-heading font-bold uppercase text-lg leading-tight" data-id="element-119" data-mp="3jdpx3telxzya">
                  {t.about.stats[1].value}
                </p>
                <p className="text-sm text-white/90 mt-1" data-id="element-120" data-mp="3870hhta2uzju">{t.about.stats[1].label}</p>
              </div>
            </div>
          </Reveal>

          <div data-id="element-121" data-mp="3d1e5hameu4eh">
            <Reveal data-id="element-122" data-mp="3hxv4izv5e36c">
              <span className="inline-flex items-center gap-2 text-orange font-semibold text-sm uppercase tracking-[0.18em]" data-id="element-123" data-mp="3hyearjbfr34j">
                <span className="h-px w-6 bg-orange" aria-hidden="true" data-id="element-124" data-mp="2kbxg6lu373mh" />
                {t.about.eyebrow}
              </span>
              <h2 className="mt-3 font-heading font-bold uppercase text-navy text-3xl sm:text-4xl leading-[1.05]" data-id="element-125" data-mp="2pbady1mhxv3u">
                {t.about.title}
              </h2>
              <p className="mt-5 text-slate-600 leading-relaxed" data-id="element-126" data-mp="2z8epz8mmoa6x">{t.about.p1}</p>
              <p className="mt-4 text-slate-600 leading-relaxed" data-id="element-127" data-mp="9j4g2w9vl06s">{t.about.p2}</p>
            </Reveal>

            <div className="mt-8 grid sm:grid-cols-2 gap-4" data-id="element-128" data-mp="egcy8wv0x481">
              <MissionVision icon={<TargetIcon size={24} data-id="element-130" data-mp="2ajhoi96edegh" />} title={t.about.missionTitle} text={t.about.mission} delay={0.05} data-id="element-129" data-mp="2akkbi60lmwr4" />
              <MissionVision icon={<EyeIcon size={24} data-id="element-132" data-mp="2jk7cwrtbw2k6" />} title={t.about.visionTitle} text={t.about.vision} delay={0.12} data-id="element-131" data-mp="2jkz1hioid00y" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function MissionVision({
  icon,
  title,
  text,
  delay
}: {
  icon: React.ReactNode;
  title: string;
  text: string;
  delay: number;
}) {
  return <Reveal delay={delay} data-id="element-133" data-mp="20neksyvwd7rf">
      <div className="h-full bg-slate-50 border-l-4 border-orange rounded-sm p-5" data-id="element-134" data-mp="20no463mfsgo5">
        <div className="flex items-center gap-3" data-id="element-135" data-mp="1vu3d6vj9gmyg">
          <span className="flex h-11 w-11 items-center justify-center rounded-sm bg-navy text-orange" data-id="element-136" data-mp="185tvo5t2yld4">
            {icon}
          </span>
          <h3 className="font-heading font-bold uppercase text-navy text-xl" data-id="element-137" data-mp="143p4ddq3u0tn">{title}</h3>
        </div>
        <p className="mt-3 text-sm text-slate-600 leading-relaxed" data-id="element-138" data-mp="tzry9ds4g1ss">{text}</p>
      </div>
    </Reveal>;
}